import MESIcon from './MESIcon';

export default MESIcon;
